import { adDesignIndexQueryKey, adDesignShowDefaultsQueryKey } from '@jobilla/nexus-sdk'
import { useQueryClient } from '@tanstack/react-query'

export function useAdDesignInvalidation() {
	const queryClient = useQueryClient()
	return async (organisationId?: string) => {
		if (!organisationId) { return }
		await Promise.all([
			queryClient.invalidateQueries({
				queryKey: adDesignIndexQueryKey(organisationId),
			}),
			queryClient.invalidateQueries({
				queryKey: adDesignShowDefaultsQueryKey(organisationId),
			}),
		])
	}
}
